import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

export const PublicNavbar = () => (
  <header className="bg-white px-6 py-4 relative z-50 border-b border-gray-100">
    <div className="flex items-center justify-between pl-[100px] pr-8">
      {/* Logo */}
      <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
        <img
          src="https://boothshop.my.canva.site/master-file/images/f240dd7de334359f1526183865a27145.svg"
          alt="EXPO STAND"
          className="w-12 h-10"
        />
        <div className="text-slate-700">
          <div className="text-xl font-semibold leading-tight">EXPO</div>
          <div className="text-xl font-semibold leading-tight">STAND</div>
        </div>
      </Link>

      {/* Nav */}
      <div className="flex items-center space-x-6 text-slate-700 text-sm">
        {/* Şehirler */}
        <Link to="/locations" className="hidden sm:flex items-center gap-1 hover:text-blue-600 transition-colors font-medium">
          <MapPin className="w-3.5 h-3.5" />Şehirler
        </Link>

        <div className="hidden sm:flex items-center space-x-2">
          <Mail className="w-4 h-4" />
          <span>hello@expostand.com</span>
        </div>

        {/* Sign In dropdown */}
        <div className="relative group">
          <span className="hover:text-blue-600 cursor-pointer flex items-center gap-1">
            Sign In <span>▾</span>
          </span>
          <div className="absolute right-0 top-full hidden group-hover:block bg-white shadow-lg rounded-md border border-gray-200 py-2 min-w-[130px] z-50">
            <Link to="/admin-login" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Exhibitor</Link>
            <Link to="/admin-login" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Contractor</Link>
            <Link to="/admin-login" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Supplier</Link>
            <div className="border-t border-gray-100 my-1" />
            <Link to="/admin-login" className="block px-4 py-2 text-sm text-red-600 font-medium hover:bg-red-50">Admin Login</Link>
          </div>
        </div>

        {/* Sign Up dropdown */}
        <div className="relative group">
          <span className="hover:text-blue-600 cursor-pointer flex items-center gap-1">
            Sign Up <span>▾</span>
          </span>
          <div className="absolute right-0 top-full hidden group-hover:block bg-white shadow-lg rounded-md border border-gray-200 py-2 min-w-[130px] z-50">
            <Link to="/exhibitor/landing" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Exhibitor</Link>
            <Link to="/contractor/signup" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Contractor</Link>
            <Link to="/supplier/signup"   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Supplier</Link>
          </div>
        </div>

        <span className="hover:text-blue-600 cursor-pointer hidden md:block">Contact</span>
      </div>
    </div>
  </header>
);

export const PublicFooter = () => (
  <footer className="bg-white border-t border-gray-100">
    <div className="pl-[100px] pr-8 py-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src="https://boothshop.my.canva.site/master-file/images/f240dd7de334359f1526183865a27145.svg"
              alt="EXPO STAND"
              className="w-10 h-8"
            />
            <div className="text-slate-700">
              <div className="text-lg font-bold leading-tight">EXPO</div>
              <div className="text-lg font-bold leading-tight">STAND</div>
            </div>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed">
            Connecting global trade fair participants with premium contractors worldwide.
          </p>
          <div className="flex items-center gap-2 mt-4 text-green-600 text-sm font-medium">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            500+ Active Projects
          </div>
        </div>

        {/* Links */}
        <div>
          <h4 className="font-semibold text-slate-800 mb-4">Platform</h4>
          <ul className="space-y-2 text-sm text-gray-500">
            <li><Link to="/locations" className="hover:text-blue-600 transition-colors">Fuar Şehirleri</Link></li>
            <li><Link to="/exhibitor/landing" className="hover:text-blue-600 transition-colors">Katılımcılar için</Link></li>
            <li><Link to="/contractor/landing" className="hover:text-blue-600 transition-colors">Yükleniciler için</Link></li>
            <li><Link to="/supplier/landing" className="hover:text-blue-600 transition-colors">Tedarikçiler için</Link></li>
            {['Help Center'].map(l => (
              <li key={l}><a href="#" className="hover:text-blue-600 transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-semibold text-slate-800 mb-4">Contact</h4>
          <div className="space-y-2 text-sm text-gray-500">
            <p>hello@expostand.com</p>
            <p>Global Network — 50+ Countries</p>
          </div>
          <div className="flex gap-3 mt-4">
            {['Privacy Policy', 'Terms'].map(l => (
              <a key={l} href="#" className="text-xs text-gray-400 hover:text-gray-600 transition-colors">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div className="border-t border-gray-100">
      <div className="pl-[100px] pr-8 py-4 flex flex-col sm:flex-row justify-between items-center text-xs text-gray-400 gap-2">
        <span>© 2025 EXPO STAND. All rights reserved.</span>
        <span>Made with ♥ for exhibitions</span>
      </div>
    </div>
  </footer>
);
